import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { RULES_VERSION } from "../lib/rules";
import RulesAcceptance from "./RulesAcceptance";

// Contas criadas antes das regras em duas partes (ou quando o texto muda de versão) precisam aceitar para continuar usando o painel.
export default function TermsGate() {
  const { account, refreshAccount, logout } = useAuth();
  const [acc, setAcc] = useState({ p1: false, p2: false });
  const [busy, setBusy] = useState(false);
  if (!account || account.terms_ok !== false) return null;
  const go = async () => {
    setBusy(true);
    try {
      await api.post("/account/terms/accept", { accept_terms: true, accept_rmt_terms: true, terms_version: RULES_VERSION });
      toast.success("Obrigado! Regras aceitas.");
      await refreshAccount();
    } catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível registrar o aceite."); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[250] flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm" data-testid="terms-gate">
      <div className="w-full max-w-[520px] rounded-2xl border border-[var(--color-main)]/40 bg-[#0b0b10] p-7 space-y-5 shadow-2xl">
        <h2 className="text-xl font-black text-white uppercase italic">Atualizamos as regras</h2>
        <p className="text-sm text-white/65">Para continuar, leia e aceite as duas partes: os Termos de Uso e as regras da economia digital (PKX Coin, RMT Bazar e reembolso).</p>
        <RulesAcceptance value={acc} onChange={setAcc} compact />
        <div className="flex gap-3 justify-end pt-2">
          <button type="button" onClick={logout} className="px-5 py-3 rounded-xl bg-white/5 border border-white/10 text-white/60 text-xs font-black uppercase cursor-pointer">Sair</button>
          <button type="button" disabled={!acc.p1 || !acc.p2 || busy} onClick={go} data-testid="terms-confirm"
            className="px-5 py-3 rounded-xl bg-[var(--color-main)] disabled:opacity-35 text-white text-xs font-black uppercase tracking-wider cursor-pointer">{busy ? "Salvando…" : "Confirmar e continuar"}</button>
        </div>
      </div>
    </div>
  );
}
